// extracted by mini-css-extract-plugin
export default {"tab-group":"Tab_tab-group__s3pql","tab":"Tab_tab__7ITAM","active":"Tab_active__xJCJh","tab-group-full":"Tab_tab-group-full__iR0pG"};